import moment from 'moment'
import {memo, useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import NodataYet from '../../../../Components/NodataYet'
import {
  GetContactListOfCampaign,
  GetReportId,
  GetSingleMessageData,
  IsLoadBulkContactList,
  exportCampaignContactsList,
  getCampaginContactsList,
  setIsLoadBulkContactList,
} from '../reportSlices/reportAnalytics'
import QuickMessageDrawerInner, {
  initialData,
} from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {pascalCase} from '../../../../Utils/AllHelperFunctions'
import {QuickMsgDraftData} from '../../../../Redux/AdminPanel/QuickMessageSlice'
import {useNavigate} from 'react-router-dom'
import {ReplyInboxData} from '../../inbox/InboxSlice/InboxSlice'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import Select from 'react-select'
import {
  useSubscribeContactMutation,
  useUnSubscribeContactMutation,
} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {KTSVG} from '../../../../../_metronic/helpers'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {useGetBulkReportDetailMessageQuery} from '../../../../../services/cellcast.v3'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

enum MessageDeliveryStatus {
  BLOCKED = 'blocked',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  RECEIVED = 'received',
  EXPIRED = 'expired',
  QUEUED = 'queued',
  SEND = 'sent',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
  PAUSED = 'paused'
}

const ContactList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const ReportId = useSelector(GetReportId)
  const messageData = useSelector(GetSingleMessageData)
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const ContactListData = useSelector(GetContactListOfCampaign)
  const [openQuickMessage, setOpenQuickMessage] = useState(false)
  const [isRefresh, setIsRefresh] = useState(false)
  const [number, setNumber] = useState({id: '', number: '', ReportId: ''})
  const [search, setSearch] = useState({
    searchValue: '',
    page: 1,
  })

  const [filterStatus, setFilterStatus] = useState<any>([])
  const isLoading = useSelector(IsLoadBulkContactList)

  const {data: contactListRegion, isLoading: isLoadingContactListRegion} =
    useGetBulkReportDetailMessageQuery(
      {
        bulk_id: ReportId?.id,
        sort_key: 'created_at',
        sort_value: 'desc',
        status: filterStatus?.value,
        page: search?.page,
      },
      {
        skip: isDefaultRegion,
      }
    )

  // subscribe
  const [selectedId, setSelectedID] = useState('')
  const [selectedIds, setSelectedIDs] = useState<any[]>([])
  const [selectedUnsubIds, setUnsubSelectedIDs] = useState<any[]>([])
  const [subscribeContact, {isLoading: subscribeLoading}] = useSubscribeContactMutation()
  const [unsubscribeContact, {isLoading: unsubscribeLoading}] = useUnSubscribeContactMutation()
  const [isOpenUnsubscribeConfirmation, setIsUnsubscribeConfirmation] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)

  const unsubscribeConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenUnsubscribeConfirmation}
        handleClose={() => {
          setIsUnsubscribeConfirmation(false)
          setSelectedID('')
        }}
        Message={'Are you sure, you want to unsubscribe contact ?'}
        confirm={() => {
          onClickUnsubscribeHandler(selectedId)
          setIsUnsubscribeConfirmation(false)
        }}
        confirmBtnTitle='Yes, unsubscribe'
      />
    ),
    [isOpenUnsubscribeConfirmation, selectedId]
  )

  const onClickSubscribeHandler = (id: any) => {
    subscribeContact({contactIDs: [id]})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error subscribe:', res.error)
        }
        setSelectedIDs((ids) => {
          return ids.filter((fID) => fID !== id)
        })
      })
      .catch((err) => {
        toast.error(err.error)
        setSelectedIDs((ids) => {
          return ids.filter((fID) => fID !== id)
        })
      })
  }

  const onClickUnsubscribeHandler = (id: any) => {
    unsubscribeContact({contactIDs: [id]})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error unsubscribe:', res.error)
        }
        setUnsubSelectedIDs((ids) => {
          return ids.filter((fID) => fID !== id)
        })
        setSelectedID('')
      })
      .catch((err) => {
        toast.error(err.error)
        setUnsubSelectedIDs((ids) => {
          return ids.filter((fID) => fID !== id)
        })
        setSelectedID('')
      })
  }

  const handleExport = () => {
    setExportLoading(true)
    let queryParam: any = {
      camp_type: ReportId?.camp_type,
      search,
    }

    if (filterStatus) {
      if (Array.isArray(filterStatus)) {
        const valueArr = filterStatus.map((obj) => obj.value)
        queryParam.status = valueArr.join(',')
      } else {
        queryParam.status = filterStatus.value
      }
    }

    dispatch(
      exportCampaignContactsList({
        id: ReportId?.id,
        params: queryParam,
      })
    )
      .unwrap()
      .then((res: any) => {
        if (res?.data?.downloadurl) {
          let basePath = API_DOMAIN || ''
          window.open(`${basePath}${res?.data?.downloadurl}`, '_self')
        }
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  useEffect(() => {
    let queryParam: any = {
      camp_type: ReportId?.camp_type,
      search,
    }

    if (filterStatus) {
      if (Array.isArray(filterStatus)) {
        const valueArr = filterStatus.map((obj) => obj.value)
        queryParam.status = valueArr.join(',')
      } else {
        queryParam.status = filterStatus.value
      }
    }

    dispatch(
      getCampaginContactsList({
        id: ReportId?.id,
        params: queryParam,
      })
    )
    dispatch(setIsLoadBulkContactList(true))
  }, [search, isRefresh, filterStatus, subscribeLoading, unsubscribeLoading])

  const renderDefaultRegion = () => {
    return (
      <>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {ContactListData?.items?.length > 0 ? (
              <div className='tab-content'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5'>
                    <thead>
                      <tr className='fw-bold text-muted text-uppercase'>
                        <th>MOBILE</th>
                        <th>FIRST NAME</th>
                        <th>LAST NAME</th>
                        <th>FULL NAME</th>
                        <th>DATE ADDED</th>
                        <th>STATUS</th>
                        <th>DELIVERY STATUS</th>
                        <th className='text-center'>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className='text-gray-600'>
                      {ContactListData?.items?.map((key: any, i: number) => {
                        return (
                          <tr key={i} className='border-dashed border-1 border-bottom'>
                            <td>{key?.mobile}</td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'lastname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'lastname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>{moment(key?.customerResponseAt)?.format('l')}</td>
                            <td>
                              <span
                                className={
                                  key?.isBlocked == true || key?.isBlockedByUser == true
                                    ? 'badge badge badge-light-danger fw-bold  fs-7  badge-square p-4  py-5'
                                    : 'badge badge-light-success green_text_badge badge-square p-4  py-5'
                                }
                              >
                                {key?.isBlocked == true || key?.isBlockedByUser == true
                                  ? 'Unsubscribed'
                                  : 'Subscribed'}
                              </span>
                            </td>
                            <td>
                              <span
                                className={
                                  key?.status == 'delivered'
                                    ? 'badge badge-light-success green_text_badge badge-square p-4  py-5'
                                    : key?.status == 'sent'
                                    ? 'badge badge badge-light-warning fw-bold  fs-7  badge-square p-4  py-5'
                                    : 'badge badge badge-light-danger fw-bold  fs-7  badge-square p-4  py-5'
                                }
                              >
                                {pascalCase(key?.status)}
                              </span>
                            </td>

                            {/* <td className='LongMessage'>{key?.customerResponse}</td> */}
                            <td className='text-center'>
                              {key?.isBlockedByUser || key?.isBlocked ? (
                                <OverlayTrigger
                                  placement='bottom'
                                  delay={{show: 250, hide: 400}}
                                  overlay={<Tooltip id='tooltip-bottom'>Subscribe</Tooltip>}
                                >
                                  <span
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                    onClick={() =>
                                      onClickSubscribeHandler(key?.contactIdd ?? key?._id)
                                    }
                                  >
                                    {key.contactIdd &&
                                    selectedIds.includes(key?.contactIdd) &&
                                    subscribeLoading ? (
                                      <Spinner />
                                    ) : (
                                      AuthenticateUser('edit-contact') && (
                                        <i className='bi bi-person-fill-add fs-5 text-success'></i>
                                      )
                                    )}
                                  </span>
                                </OverlayTrigger>
                              ) : (
                                AuthenticateUser('edit-contact') && (
                                  <OverlayTrigger
                                    placement='bottom'
                                    delay={{show: 250, hide: 400}}
                                    overlay={<Tooltip id='tooltip-bottom'>Unsubscribe</Tooltip>}
                                  >
                                    <span
                                      className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                      onClick={() => {
                                        setSelectedID(key?.contactIdd)
                                        setIsUnsubscribeConfirmation(true)
                                      }}
                                    >
                                      {key._id &&
                                      selectedUnsubIds.includes(key?.contactIdd) &&
                                      unsubscribeLoading ? (
                                        <Spinner />
                                      ) : (
                                        <i className='bi bi-person-fill-dash fs-5 text-danger'></i>
                                      )}
                                    </span>
                                  </OverlayTrigger>
                                )
                              )}
                              {!key?.isReplied ? (
                                <>
                                  {AuthenticateUser('send-quick-sms') && (
                                    <button
                                      onClick={() => {
                                        setNumber({id: key?._id, number: key?.mobile, ReportId})
                                        dispatch(
                                          QuickMsgDraftData({
                                            ...initialData,
                                            contacts: [{value: key?.mobile, label: key?.mobile}],
                                            camp_type: messageData?.camp_type,
                                            sender: messageData?.sender,
                                            senderType: messageData?.senderType,
                                          })
                                        )
                                        setOpenQuickMessage(true)
                                      }}
                                      style={{backgroundColor: '#F6F8FA', color: '#A2A5B5'}}
                                      className='ms-2 btn btn-sm fw-500'
                                    >
                                      Reply
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {AuthenticateUser('show-inbox') && (
                                    <button
                                      onClick={() => {
                                        dispatch(ReplyInboxData({receiver: key?.mobile}))
                                        navigate('/inbox')
                                      }}
                                      className='ms-2 btn btn-sm fw-500 btn-primary text-white'
                                    >
                                      Response
                                    </button>
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet />
            )}
          </>
        )}
        {ContactListData?.items?.length > 0 && (
          <div className='abcd '>
            <span>Total: {ContactListData?.total} </span>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={ContactListData?.totalPages}
              onPageChange={(e) => setSearch({...search, page: e.selected + 1})}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        )}
      </>
    )
  }

  const renderRegionData = () => {
    return (
      <>
        {isLoadingContactListRegion ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {contactListRegion?.data?.items?.length > 0 ? (
              <div className='tab-content'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5'>
                    <thead>
                      <tr className='fw-bold text-muted text-uppercase'>
                        <th>MOBILE</th>
                        <th>FIRST NAME</th>
                        <th>LAST NAME</th>
                        <th>FULL NAME</th>
                        <th>DATE ADDED</th>
                        <th>STATUS</th>
                        <th>DELIVERY STATUS</th>
                      </tr>
                    </thead>
                    <tbody className='text-gray-600'>
                      {contactListRegion?.data?.items?.map((key: any, i: number) => {
                        return (
                          <tr key={i} className='border-dashed border-1 border-bottom'>
                            <td>{key?.mobile}</td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'lastname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'lastname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>{moment(key?.customerResponseAt)?.format('l')}</td>
                            <td>
                              <span
                                className={
                                  key?.isBlocked == true || key?.isBlockedByUser == true
                                    ? 'badge badge badge-light-danger fw-bold  fs-7  badge-square p-4  py-5'
                                    : 'badge badge-light-success green_text_badge badge-square p-4  py-5'
                                }
                              >
                                {key?.isBlocked == true || key?.isBlockedByUser == true
                                  ? 'Unsubscribed'
                                  : 'Subscribed'}
                              </span>
                            </td>
                            <td>
                              <span
                                className={
                                  key?.status == 'delivered'
                                    ? 'badge badge-light-success green_text_badge badge-square p-4  py-5'
                                    : key?.status == 'sent'
                                    ? 'badge badge badge-light-warning fw-bold  fs-7  badge-square p-4  py-5'
                                    : 'badge badge badge-light-danger fw-bold  fs-7  badge-square p-4  py-5'
                                }
                              >
                                {pascalCase(key?.status)}
                              </span>
                            </td>

                            {/* <td className='LongMessage'>{key?.customerResponse}</td> */}
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet />
            )}
          </>
        )}
        {contactListRegion?.data?.items?.length > 0 && (
          <div className='abcd '>
            <span>Total: {contactListRegion?.data?.total} </span>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={contactListRegion?.data?.totalPages}
              onPageChange={(e) => setSearch({...search, page: e.selected + 1})}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {unsubscribeConfirmation}
      {AuthenticateUser('send-quick-sms') && openQuickMessage && (
        <QuickMessageDrawerInner
          show={openQuickMessage}
          handleClose={() => {
            setIsRefresh(!isRefresh)
            setOpenQuickMessage(false)
          }}
          CustomReplyReport={number}
          setCustomReplyReport={() => setNumber({id: '', number: '', ReportId: ''})}
        />
      )}
      <div className='card mb-0 pt-7'>
        <div className='card-header align-items-center border-bottom-0'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Contacts</span>
            <span className='text-muted mt-1 fw-bold fs-7'>All contacts messages was sent to</span>
          </h3>
          <div className='d-flex justify-content-end'>
            <div className='ms-2 col-xs-4'>
              <Select
                value={filterStatus}
                isMulti={false}
                options={[
                  {
                    value: MessageDeliveryStatus.BLOCKED,
                    label: MessageDeliveryStatus.BLOCKED.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.DELIVERED,
                    label: MessageDeliveryStatus.DELIVERED.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.FAILED,
                    label: MessageDeliveryStatus.FAILED.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.RECEIVED,
                    label: MessageDeliveryStatus.RECEIVED.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.EXPIRED,
                    label: MessageDeliveryStatus.EXPIRED.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.QUEUED,
                    label: MessageDeliveryStatus.QUEUED.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.SEND,
                    label: MessageDeliveryStatus.SEND.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.REJECTED,
                    label: MessageDeliveryStatus.REJECTED.toString().toUpperCase(),
                  },
                  {
                    value: MessageDeliveryStatus.CANCELED,
                    label: MessageDeliveryStatus.CANCELED.toString().toUpperCase(),
                  },
                                    {
                    value: MessageDeliveryStatus.PAUSED,
                    label: MessageDeliveryStatus.PAUSED.toString().toUpperCase(),
                  },
                ]}
                onChange={(e: any) => {
                  setFilterStatus(e)
                  // setSearch({...search, page: 1})
                }}
                isDisabled={isLoading}
              />
            </div>
            <div className='ms-2 col-xs-2'>
              {isDefaultRegion && (
                <button onClick={handleExport} type='button' className='btn btn-light-primary'>
                  {exportLoading ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      {' '}
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>

        <div className='card-body pt-2'>
          {isDefaultRegion ? renderDefaultRegion() : renderRegionData()}
        </div>
      </div>
    </>
  )
}

export default memo(ContactList)
